<div class="content ingame door-editor">

  <div class="items-door">
    <div class="item-game" (click)="pickTimer()" [@inboundLeft]>
      <config-option [item]="door?.timer?.timer? door?.timer?.timer : dummyTimer" (onSelect)="pickTimer()"
        class="item-door-option">
      </config-option>
    </div>
    <div class="item-game" (click)="pickLock()" [@inboundLeft]>
      <config-option [item]="gameLock" (onSelect)="pickLock()" class="item-door-option">

      </config-option>
    </div>

    <div class="save-button button button-tercery" (click)="save()" [@inboundLeft]>
      <span>GUARDAR PUERTA</span>
    </div>
  </div>

</div>

<div class="picker" *ngIf="displayPicker" [@pickerAnimation]>
  <div class="picker-content">
    <div class="title">
      <span class="close" (click)="displayPicker=false"><i class="fa fa-close"></i></span>
      <span class="title">{{title}}</span>
    </div>

    <div class="options">
      <config-option *ngFor="let item of options" [item]="item" (onSelect)="optionSelected(item)">
      </config-option>
    </div>
  </div>
</div>
